import { message, PageHeader, Spin, Upload, Row, Col, Alert, Descriptions, Tag } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Form, FormItem, TableItem, ButtonItem } from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import { descargarPlantillaMatriz, leerPlantillaMatriz } from "../plantillaMatriz.utils";
import { tipoMatrizInfo } from "../matriz.utils";

class ImportarMatrices extends Component {
  state = {
    loading: false,
    archivosExcel: [],
    catalogos: null,
    matriz: null,
    errores: [],
  };

  componentDidMount() {
    this.setState({ loading: true });
    axios
      .post(
        "matrices/datosParaPlantillaMatriz",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false, catalogos: res.data.success === 2 ? res.data : null });
        if (res.data.success !== 2) message.error("No se pudieron cargar los catálogos");
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudieron cargar los catálogos");
      });
  }

  atras() {
    this.props.history.goBack();
  }

  async onChangeArchivo(e) {
    if (!this.state.catalogos) return;
    this.setState({
      loading: true,
      archivosExcel: [{ ...e.file, name: e.file.name, status: "uploading" }],
    });
    try {
      const { errores, matriz } = await leerPlantillaMatriz(e.file, this.state.catalogos);
      this.setState({
        archivosExcel: [{ ...e.file, name: e.file.name, status: "success", response: errores.length ? "Con errores" : undefined }],
        errores,
        matriz,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false, archivosExcel: [], errores: [], matriz: null });
      message.error("El archivo debe ser un Excel (.xlsx) con la plantilla de matriz");
    }
  }

  onFinish() {
    this.setState({ loading: true });
    axios
      .post(
        "matrices/importarMatriz",
        { empresaId: this.props.empresaId, matriz: this.state.matriz },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se importó la matriz");
          this.props.history.replace("/panel/editarMatriz", { id: res.data.matrizId });
        } else {
          message.error(res.data.message || "Hubo un error y la matriz no se importó");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error y la matriz no se importó");
      });
  }

  render() {
    const { matriz, errores, catalogos } = this.state;
    const puedeImportar = matriz && errores.length === 0;
    const tipo = matriz ? tipoMatrizInfo(matriz.tipoMatriz) : null;
    const columns = [
      { title: "Clave insumo", dataIndex: "clave", key: "clave", width: 140 },
      { title: "Nombre", dataIndex: "nombre", key: "nombre" },
      { title: "Unidad", dataIndex: "unidad", key: "unidad", width: 120 },
      { title: "Cantidad", dataIndex: "cantidad", key: "cantidad", width: 110, align: "right" },
    ];
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Importar Matriz"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando, espere por favor">
            <Form
              name="importarMatrices"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  disabled={!puedeImportar}
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Importar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
            >
              <Alert
                type="info"
                showIcon
                style={{ marginTop: 10, marginBottom: 10 }}
                message="Instrucciones"
                description={
                  <ol style={{ margin: 0, paddingLeft: 20 }}>
                    <li>Descargue la plantilla. Trae sus insumos, matrices base, unidades, familias, tipos de insumo, impuestos y retenciones en hojas de consulta.</li>
                    <li>En las filas 1 a 7 capture los datos de la matriz. Clave, Descripción, Unidad, Familia y Tipo son obligatorios; Descripción larga, Código de barras, Tipo de insumo, Código SAT, Impuestos y Retenciones son opcionales.</li>
                    <li>A partir de la fila 9 capture un insumo por fila: Clave insumo, Nombre, Unidad y Cantidad.</li>
                    <li>Es una matriz por archivo. Se crea como borrador y con costo 0 hasta actualizar costos.</li>
                    <li>Suba el archivo y revise la vista previa antes de importar.</li>
                  </ol>
                }
              />
              <Row style={{ marginTop: 20 }}>
                <Col span={12} xs={24} sm={24} lg={12} xl={12} style={{ display: "flex", justifyContent: "center" }}>
                  <ButtonItem
                    type="primary"
                    disabled={!catalogos}
                    onClick={() => descargarPlantillaMatriz(catalogos)}
                  >
                    Descargar Plantilla
                  </ButtonItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem name="archivo" label="Archivo">
                    <Upload
                      showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                      fileList={this.state.archivosExcel}
                      customRequest={this.onChangeArchivo.bind(this)}
                      accept=".xlsx"
                    >
                      <ButtonItem icon={<UploadOutlined />}>Subir</ButtonItem>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
            </Form>
            {errores.length > 0 && (
              <Alert
                type="error"
                showIcon
                style={{ marginBottom: 12 }}
                message={`Se detectaron ${errores.length} error(es). Corrija el archivo y vuelva a subirlo.`}
                description={
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {errores.map((error) => <li key={error}>{error}</li>)}
                  </ul>
                }
              />
            )}
            {puedeImportar && (
              <>
                <Descriptions size="small" bordered column={{ xs: 1, sm: 2, lg: 3 }} style={{ marginBottom: 12 }}>
                  <Descriptions.Item label="Clave">{matriz.clave}</Descriptions.Item>
                  <Descriptions.Item label="Descripción">{matriz.descripcion}</Descriptions.Item>
                  <Descriptions.Item label="Tipo">{tipo ? <Tag color={tipo.color}>{tipo.label}</Tag> : null}</Descriptions.Item>
                  <Descriptions.Item label="Permitir venta">{matriz.venta ? "SI" : "NO"}</Descriptions.Item>
                  <Descriptions.Item label="Descripción larga">{matriz.descripcionLarga || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Código de barras">{matriz.codigoBarras || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Tipo de insumo">{matriz.tipoDeInsumo || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Código SAT">{matriz.codigoSat || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Impuestos">{matriz.nombresImpuestos.join(", ") || "-"}</Descriptions.Item>
                  <Descriptions.Item label="Retenciones">{matriz.nombresRetenciones.join(", ") || "-"}</Descriptions.Item>
                </Descriptions>
                <TableItem
                  size="small"
                  dataSource={matriz.partidas}
                  columns={columns}
                  rowKey="clave"
                />
              </>
            )}
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ImportarMatrices);
